import { isTenxPublishingTool } from "./tenx-publishing-tool"

type ToolPartLike = {
  tool: string
  state: { status: string; error?: unknown }
}

/**
 * The message the generic tool-error card should render for a part, or null when
 * the part is not a renderable generic error (not an error, an empty error, or a
 * 10x publishing tool — those cards render their own error state).
 *
 * This used to be an inline `<Match when={status === "error" && state.error && !isTenxPublishingTool(tool)}>`
 * whose child did `error().replace(...)`. Solid hands the child the VALUE of `when`,
 * and `a && b && c` evaluates to its last operand — so appending the publishing
 * exclusion turned that value from the error string into `true`, and every tool
 * error in the app crashed the timeline with "error().replace is not a function".
 * Keeping the decision here, typed as `string | null`, makes that impossible, and
 * coerces non-string errors (an Error, a `{ message }` object) instead of throwing.
 */
export function toolErrorMessage(part: ToolPartLike): string | null {
  if (part.state.status !== "error") return null
  if (isTenxPublishingTool(part.tool)) return null
  const raw = part.state.error
  const text =
    typeof raw === "string"
      ? raw
      : raw instanceof Error
        ? raw.message
        : raw && typeof raw === "object" && typeof (raw as { message?: unknown }).message === "string"
          ? (raw as { message: string }).message
          : raw == null
            ? ""
            : String(raw)
  const trimmed = text.trim()
  return trimmed ? trimmed : null
}
